import { useState } from "react"
import GestionOC from "./GestionOC"
import GestionPaciente from "./GestionPaciente"
import GestionUsuarios from "./GestionUsuarios"
import GestionProductos from "./GestionProductos"
import Reportes from "./Reportes"

const TABS = [
  { id: "gestion-oc",         label: "Gestión OC",          component: GestionOC },
  { id: "gestion-paciente",   label: "Gestión Pacientes",   component: GestionPaciente },
  { id: "gestion-usuarios",   label: "Gestión Usuarios",    component: GestionUsuarios },
  { id: "gestion-productos",  label: "Gestión Productos",   component: GestionProductos },
  { id: "reportes",           label: "Reportes",            component: Reportes },
]

function AdminPanel() {
  const [activeTab, setActiveTab] = useState("gestion-oc")
  const ActiveComponent = TABS.find(t => t.id === activeTab)?.component

  return (
    <div className="pageContainer">
      <div className="adminPanelPage column">
        <div className="adminTabs row">
          {TABS.map(tab => (
            <div
              key={tab.id}
              className={`adminTab${activeTab === tab.id ? " adminTab--active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon ? <i className={tab.icon}></i> : tab.label}
            </div>
          ))}
        </div>
        <div className="adminTabContent">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </div>
  )
}

export default AdminPanel
